import * as React from 'react';
import { defaultProps } from './Typography.mappers.js';
import { TypographyStyled } from './Typography.styled.js';
import { useTypography } from './useTypography.js';

var Typography = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useTypography = useTypography({
      props: props,
      ref: ref
    }),
    styledProps = _useTypography.styledProps,
    children = _useTypography.children;
  return /*#__PURE__*/React.createElement(TypographyStyled, styledProps, children);
});
Typography.displayName = 'Typography';
Typography.defaultProps = defaultProps;

export { Typography };
//# sourceMappingURL=Typography.js.map
